"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EditDeployment = function EditDeployment(_ref) {
  var deployment = _ref.deployment,
    index = _ref.index,
    arrayHelpers = _ref.arrayHelpers;
  var displayNameFieldName = "course.curriculumOptions[".concat(index, "].displayName");
  var descriptionFieldName = "course.curriculumOptions[".concat(index, "].description");
  var iconFieldName = "course.curriculumOptions[".concat(index, "].icon");
  var defaultDescription = '';
  var defaultDisplayName = deployment.assignment.label;
  var defaultIcon = null;
  var assignmentCourseDescription = (0, _get2["default"])(deployment, 'assignment.settings.navigationSettings.courseDescription.introduction.main', null);

  // values to save when modal closes (user may save changes or discard them)
  var _useState = (0, _react.useState)(defaultDisplayName),
    _useState2 = _slicedToArray(_useState, 2),
    displayNameToSave = _useState2[0],
    setDisplayNameToSave = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultDescription),
    _useState4 = _slicedToArray(_useState3, 2),
    descriptionToSave = _useState4[0],
    setDescriptionToSave = _useState4[1];
  var _useState5 = (0, _react.useState)(defaultIcon),
    _useState6 = _slicedToArray(_useState5, 2),
    iconToSave = _useState6[0],
    setIconToSave = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    populateDescCount = _useState8[0],
    setPopulateDescCount = _useState8[1];
  function setIntialValues() {
    setDisplayNameToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(displayNameFieldName), defaultDisplayName));
    setDescriptionToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(descriptionFieldName), defaultDescription));
    setIconToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(iconFieldName), defaultIcon));
  }
  var renderEditForm = function renderEditForm(_ref2) {
    var closeModal = _ref2.closeModal;
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: displayNameFieldName,
      component: _cccisdFormik.CccisdInput,
      label: "Assignment Display Name:",
      placeholder: defaultDisplayName
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: descriptionFieldName
    }, function (fieldProps) {
      var field = fieldProps.field,
        form = fieldProps.form;
      function handleChange(val) {
        field.onChange(val);
        form.setFieldValue(descriptionFieldName, val);
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({}, fieldProps, {
        label: /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].descriptionLabel
        }, /*#__PURE__*/_react["default"].createElement("span", null, "Description"), assignmentCourseDescription && /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-xs btn-link",
          type: "button",
          onClick: function onClick() {
            setPopulateDescCount(function (prev) {
              return prev + 1;
            });
            arrayHelpers.form.setFieldValue(descriptionFieldName, assignmentCourseDescription);
          }
        }, "Populate Course Description"))
      }), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: field.value || '',
        onBlur: field.onBlur,
        onChange: handleChange,
        type: "textarea",
        settings: {
          height: '290px'
        }
        // force react to re-render on update
        ,
        key: descriptionFieldName + populateDescCount
      }));
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: iconFieldName
    }, function (fieldProps) {
      var setIcon = function setIcon(val) {
        fieldProps.form.setFieldValue(iconFieldName, val);
      };
      var currImage = (0, _get2["default"])(fieldProps, "field.value", null) || null;
      var width = (0, _get2["default"])(currImage, 'metadata.width', null);
      var height = (0, _get2["default"])(currImage, 'metadata.height', null);
      var ratio = width && height && width / height;
      var isWarning = ratio && (ratio > 1.2 || ratio < 0.8);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({}, fieldProps, {
        label: "Icon"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].iconContainer
      }, currImage && /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].iconPreview,
        style: {
          backgroundImage: "url(".concat(currImage.url, ")")
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
        value: currImage || -1,
        onChange: setIcon,
        trigger: currImage ? /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: 'btn btn-default ' + _style["default"].changeIconButton
        }, "Change") : /*#__PURE__*/_react["default"].createElement("span", {
          className: "".concat(_style["default"].iconPreview, " ").concat(_style["default"].noValue),
          role: "button"
        }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), "\xA0\xA0Add")
      }), currImage && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-danger",
        onClick: function onClick() {
          return setIcon(null);
        }
      }, "Remove")), isWarning && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-warning"
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null), "\xA0\xA0Icon dimensions should be as square as possible to maximize visibility."));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].btnContainer
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return closeModal();
      }
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      onClick: function onClick() {
        // only clicking SAVE will not revert formik state back to initial values
        setDisplayNameToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(displayNameFieldName), defaultDisplayName));
        setDescriptionToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(descriptionFieldName), defaultDescription));
        setIconToSave((0, _get2["default"])(arrayHelpers, "form.values.".concat(iconFieldName), defaultIcon));
        closeModal();
      },
      disabled: (0, _get2["default"])(arrayHelpers, "form.values.".concat(displayNameFieldName), defaultDisplayName) === displayNameToSave && (0, _get2["default"])(arrayHelpers, "form.values.".concat(descriptionFieldName), defaultDescription) === descriptionToSave && (0, _get2["default"])(arrayHelpers, "form.values.".concat(iconFieldName), defaultIcon) === iconToSave
    }, "Continue")));
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "".concat(deployment.assignment.label, " (").concat(deployment.label, ")"),
    trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Edit Details"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-xs btn-success ' + _style["default"].editDraggable
    }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
    render: renderEditForm,
    beforeShow: setIntialValues,
    afterClose: function afterClose() {
      arrayHelpers.form.setFieldValue(displayNameFieldName, displayNameToSave);
      arrayHelpers.form.setFieldValue(descriptionFieldName, descriptionToSave);
      arrayHelpers.form.setFieldValue(iconFieldName, iconToSave);
    },
    contentStyle: {
      maxWidth: '650px',
      width: 'calc(100vw - 30px)',
      margin: '15px auto'
    }
  });
};
EditDeployment.propTypes = {
  arrayHelpers: _propTypes["default"].object.isRequired,
  deployment: _propTypes["default"].object.isRequired,
  index: _propTypes["default"].number.isRequired
};
var _default = EditDeployment;
exports["default"] = _default;